import {
  useQuery,
  useMutation,
  useQueryClient,
  keepPreviousData,
} from "@tanstack/react-query";
import { tgcmService } from "../services/svc_tgcm";
import { queryKeys } from "../lib/queryKeys";
import { ListRequestSchemaV2 } from "../types/common/commonTypes";

export const useTSQTGCMList = (
  params: ListRequestSchemaV2,
  source: string,
  enabled: boolean = true,
) => {
  return useQuery({
    queryKey: queryKeys.tgcm.list(params, source),
    queryFn: () => tgcmService.listTGCM(params),
    placeholderData: keepPreviousData,
    enabled: enabled,
  });
};
